import StackKit from "@/shared/components/kit/stack";
import React from "react";

interface CardBoxLayoutProps {
  children: React.ReactNode;
  sx?: any;
  className?: string;
}
/**
 * CardBoxLayout
 *
 * یک لایه کارت‌باکس قابل استفاده مجدد برای نمایش محتوا با پس‌زمینه گرادیان و گوشه‌های گرد.
 *
 * ویژگی‌ها:
 * - دریافت children برای نمایش محتوای داخلی
 * - دریافت sx برای اعمال استایل‌های سفارشی
 * - دریافت className برای اضافه کردن کلاس‌های CSS دلخواه
 * - دارای ارتفاع حداقل و حداکثر و overflow-auto برای اسکرول محتوا
 *
 * @param children محتوای داخلی کارت
 * @param sx استایل‌های سفارشی اضافه
 * @param className کلاس‌های CSS دلخواه
 * @returns JSX.Element
 */

// Task Response:

// کامپوننت CardBoxLayout به درستی طراحی شده و ویژگی‌های واکنش‌گرا را دارد.
// پیشنهادات بهبود:
// 1. می‌توان maxHeight را از props دریافت کرد تا در صفحات مختلف قابل تنظیم باشد.
// 2. اگر از Scrollbar سفارشی استفاده می‌کنید، می‌توان overflow-auto را با استایل‌های سفارشی جایگزین کرد.
// 3. جهت هماهنگی با سیستم طراحی، padding و gap می‌توانند از theme دریافت شوند.

const CardBoxLayout: React.FC<CardBoxLayoutProps> = ({ children, sx, className }) => {
  return (
    <StackKit
      direction="column"
      className={`w-full min-h-[456px] rounded-lg p-2 overflow-auto ${className || ""}`}
      sx={{
        background: "linear-gradient(137.33deg, rgba(0, 0, 0, 0.6) -17.41%, rgba(64, 64, 64, 0.38) 24.51%, rgba(115, 103, 240, 0.2) 75.94%, rgba(0, 0, 0, 0.4) 111.96%)",
        justifyContent: "start",
        maxHeight: "700px",
        ...sx,
      }}
    >
      {children}
    </StackKit>
  );
};

export default CardBoxLayout;
